<aside class="sidebar-wrapper sidebar-outline d-flex flex-column justify-content-between position-relative overflow-hidden">

  <!-- BRAND HEADER -->
  <div class="sidebar-header">
    <SidebarBrand
      :logo="logo"
      :title="brand_title"
      :subtitle="brand_subtitle"
    />

    <!-- 🔴 MOBILE CLOSE ACTION -->
    <slot name="sidebar-header-actions"></slot>
  </div>

  <div class="sidebar-divider mx-3"></div>

  <!-- ========== SCROLL AREA ========== -->
  <div class="sidebar-scroll-area flex-grow-1">

    <!-- CONTEXT BLOCK -->
    <slot name="context"></slot>


    <!-- MENU BLOCK -->
    <slot name="menu"></slot>

  </div>

  <slot name="footer-actions"></slot>

  <!-- ========== FOOTER (USER INFO) ========== -->
  <SidebarUserFooter
    :initials="initials"
    :full_name="full_name"
  />

</aside>
